// extracted by mini-css-extract-plugin
export default {"hero":"DangerZone_hero__5-fm0","page_hero":"DangerZone_page_hero__i6Z8O","wrapper":"DangerZone_wrapper__KaEsk","actions":"DangerZone_actions__RxPs3","btn":"DangerZone_btn__EJDeS"};